import { Tag } from "data/types";
import Link from "next/link";
import React from "react";

export interface TagComponentProps {
  tag: Tag;
}

export const TagComponent: React.FC<TagComponentProps> = ({ tag }) => {
  return (
    <Link
      href={{ pathname: "/search", query: { q: tag.name } }}
      className="bg-primary-12/5 dark:bg-primary-1/80 inline-block cursor-pointer rounded-full text-sm transition-[background-color,border-color] duration-300 [-webkit-tap-highlight-color:transparent]"
    >
      <span className="border-primary-12/10 dark:border-primary-1 inline-block rounded-l-full border border-r-0 pr-1.5 pl-2">
        {tag.name}
      </span>
      <span className="border-primary-12/10 bg-primary-12/5 dark:border-primary-1 dark:bg-primary-12/10 inline-block rounded-r-full border border-l-0 pr-2 pl-1.5">
        {tag.count}
      </span>
    </Link>
  );
};
